var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentDefinition,{tag:"component",class:{ 'radio-info': _vm.variant === 'info' },attrs:{"autoFocus":_vm.autoFocus,"checked":_vm.checked,"defaultChecked":_vm.defaultChecked,"disabled":_vm.disabled,"value":_vm.value},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }